export const ACTIONS = {
  SET_COUNTRIES_API: 'SET_COUNTRIES_API',
  SET_COUNTRY_API: 'SET_COUNTRY_API',
  SET_USERLOGIN: 'SET_USERLOGIN',
  SET_COUNTRIES_WithPlaces_API: 'SET_COUNTRIES_WithPlaces_API',
};
